<template>
  <b-dropdown id="form-actions" toggle-tag="div" toggle-class="p-0 bg-transparent">
    <template #button-content>
      <McButton
        variant="secondary"
        icon="icon-outline_chevron-down"
        icon-position="right"
        text="Lainnya"
      />
    </template>

    <b-dropdown-item @click="handleClick">Riwayat Addendum</b-dropdown-item>
  </b-dropdown>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  methods: {
    handleClick() {
      this.$router.push({
        name: 'Master Vendor Contract Addendum History',
        params: { ...this.$route.params },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(#form-actions) {
  .dropdown-menu {
    right: 0px;
    left: auto !important;
  }

  .dropdown-toggle {
    border: none;
  }
}
</style>
